import InlineImageViewState from '../schema/InlineImageViewState';
import ImageStatus from '../schema/ImageStatus';
import setImageState from '../actions/setImageState';
import { EditorViewState, lazyOperateContent } from 'owa-editor';
import { getPalette } from 'owa-theme';
import {
    INSERT_OPTION,
    PLACEHOLDER_LOAD_PENDING_ATTRIBUTE_NAME,
    INSERT_PLACEHOLDER_CHANGE_SOURCE,
} from './constants';

// Default place holder dimension
const DEFAULT_PLACEHOLDER_WIDTH = 320;
const DEFAULT_PLACEHOLDER_HEIGHT = 220;

export default async function insertPlaceholderImage(
    viewState: InlineImageViewState,
    editorViewState: EditorViewState,
    temporaryId: string,
    fileName: string,
    placeholderImageWidth: number,
    placeholderImageHeight: number
) {
    const operateContent = await lazyOperateContent.import();
    const entry = viewState.imageStatusMap[temporaryId];
    if (entry?.status == ImageStatus.Started) {
        operateContent(editorViewState, (editor, range) => {
            const placeholderNode = generatePlaceholderNode(
                editor.getDocument(),
                temporaryId,
                fileName,
                placeholderImageWidth,
                placeholderImageHeight
            );
            editor.addUndoSnapshot(() => {
                editor.insertNode(placeholderNode, INSERT_OPTION);
            }, INSERT_PLACEHOLDER_CHANGE_SOURCE);
            const actualWidth = placeholderNode.offsetWidth;
            if (actualWidth < placeholderImageWidth) {
                // Resize placeholder node proportionally.
                placeholderNode.style.height =
                    Math.ceil(
                        (actualWidth / placeholderImageWidth) * placeholderImageHeight
                    ).toString() + 'px';
            }

            setImageState(viewState, temporaryId, ImageStatus.PlaceholderShown, placeholderNode);

            return range;
        });
    }
}

function generatePlaceholderNode(
    doc: Document,
    temporaryId: string,
    fileName: string,
    placeholderWidth: number,
    placeholderHeight: number
): HTMLDivElement {
    const placeholderDiv = doc.createElement('div');
    const style = placeholderDiv.style;
    if (placeholderWidth == 0 || placeholderHeight == 0) {
        placeholderWidth = DEFAULT_PLACEHOLDER_WIDTH;
        placeholderHeight = DEFAULT_PLACEHOLDER_HEIGHT;
    }
    style.display = 'inline-block';
    style.maxWidth = '100%';
    style.borderWidth = '1px';
    style.borderStyle = 'dashed';
    style.borderColor = getPalette().themePrimary;
    style.boxSizing = 'border-box';
    style.width = placeholderWidth.toString() + 'px';
    style.height = placeholderHeight.toString() + 'px';
    placeholderDiv.title = fileName;
    placeholderDiv.contentEditable = 'false';
    placeholderDiv.setAttribute('tempid', temporaryId);
    placeholderDiv.setAttribute(PLACEHOLDER_LOAD_PENDING_ATTRIBUTE_NAME, 'true');
    return placeholderDiv;
}
